import { useAppSelector } from 'store/hooks';
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { SIGN_IN } from 'config/routes';
import { ApplicationState } from 'store/store';
import { Throbber } from 'ui/Throbber';

export const PrivateRoute: React.FC = () => {
    const location = useLocation();
    const auth = useAppSelector(
        (state: ApplicationState) => state.auth,
        (left, right) => left.authorizedDate?.toString() === right.authorizedDate?.toString()
    );
    if (auth.isAuthorizingInProgress) {
        return <Throbber />;
    }
    if (!auth.claims) {
        // Preserve the attempted URL so sign-in can forward the user back here after login.
        const redirectTo = encodeURIComponent(`${location.pathname}${location.search}`);
        return <Navigate to={`${SIGN_IN}?redirectTo=${redirectTo}`} replace />;
    }
    return <Outlet />;
};
